import styled from 'styled-components'

const SpinContainer = styled.div`
  align-self: center;
  text-align: center;
  width: 100%;
  margin: 45px;
`

export default SpinContainer